import React from 'react';
import { Result, Button } from 'antd';
import { FrownOutlined, WarningOutlined } from '@ant-design/icons';

const ErrorState = ({ type }) => {
  if (type === 'not-found') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
        <Result
          icon={<FrownOutlined />}
          title="Recipe Not Found"
          subTitle="This recipe link may have expired or been removed."
          extra={
            <Button type="primary" href="/">
              Go to NomNom
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
      <Result
        icon={<WarningOutlined />}
        status="error"
        title="Unable to Load Recipe"
        subTitle="Please try again later."
        extra={
          <Button type="primary" onClick={() => window.location.reload()}>
            Retry
          </Button>
        }
      />
    </div>
  );
};

export default ErrorState;
